import { store } from 'redux/store';
import { useState } from 'react';
import { Range } from 'types';

import { getHoldingClassAvailableRange } from 'modules/partners/api/getHoldingClassAvailableRange';

type GetAvailableRangeByHoldingClassProps = {
  holdingClassId: string;
  sharesCount: number;
  useFirstAvailableRange?: boolean;
};

export const useGetAvailableRangeByHoldingClass = () => {
  const [availableRange, setAvailableRange] = useState<Range>({
    from: 1,
    to: 1,
  });
  const [addedRanges, setAddedRanges] = useState<Range[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchAvailableRange = async ({
    holdingClassId,
    sharesCount,
    useFirstAvailableRange = false,
  }: GetAvailableRangeByHoldingClassProps) => {
    try {
      if (!holdingClassId || !sharesCount) {
        setAvailableRange({ from: 0, to: 0 });
        return;
      }

      setIsLoading(true);

      const availableRange = await getHoldingClassAvailableRange({
        holdingClassId,
        sharesCount,
        addedRanges,
        useFirstAvailableRange,
      });

      if (availableRange) {
        setAvailableRange(availableRange);
      }

      setIsLoading(false);
    } catch (error) {
      setAvailableRange({ from: 0, to: 0 });
      setIsLoading(false);
    }
  };

  const handleAddRange = (newRange: Range) => {
    setAddedRanges((prevRanges) => [...prevRanges, newRange]);
  };

  const handleValidateRange = async ({
    holdingClassId,
    sharesCount,
    useFirstAvailableRange = false,
  }: GetAvailableRangeByHoldingClassProps) => {
    fetchAvailableRange({
      holdingClassId,
      sharesCount,
      useFirstAvailableRange,
    });
  };

  return {
    data: { availableRange },
    actions: { handleAddRange, handleValidateRange },
    isLoading,
    isError: false,
  };
};
